import React from 'react'

export const AccountsApiContext = React.createContext({ apiContext: null })
